import { ID } from 'shared/types/id';
import { goalInboxID } from 'shared/types/orderable-section';
import { SortingMode } from 'shared/types/sorting-mode';

import { getUser, getUserRef } from './get-user';
import { updateDocWithTimestamp } from './helpers';

export const updateTodayGoalTaskOrder = async (
  goalSorting: { goalId: ID; taskIds: ID[] }[],
) => {
  const user = await getUser();
  // without a user we cannot update anything.
  if (!user) {
    return;
  }

  const userRef = await getUserRef();

  if (!userRef) {
    return;
  }

  const settingsToUpdate = goalSorting.reduce<
    Record<string, ID[] | SortingMode>
  >(
    (acc, { goalId, taskIds }) => {
      acc[
        `settings.todayGroupSorting.goal.sorting.${goalId === goalInboxID ? null : goalId}`
      ] = taskIds;
      return acc;
    },
    {
      'settings.todoSortingMode': SortingMode.Custom,
    },
  );

  updateDocWithTimestamp(userRef, settingsToUpdate);
};
